import { observer } from 'mobx-react';
import { useCallback } from 'react';

// Hooks
import { useGooglePlacesApi } from 'hooks/use-google-places-api';
import { useStores } from 'hooks/use-stores';

// Constants
import { TODO } from 'utils/Types';
import { StyledAddressInput } from './styles';

interface LandingPageAddressInputProps {
  onAddressObjectChange: (addressObject: any) => void;
  onLoading: (loading: boolean) => void;
  onLocationsChange: (event: any) => void;
  customersById: TODO;
  className?: string;
  onQueryChange?: (event: any) => void;
  placeholder?: string;
}

function LandingPageAddressInput({
  className,
  customersById,
  onAddressObjectChange,
  onLoading,
  onLocationsChange,
  onQueryChange,
  placeholder = 'Address',
}: LandingPageAddressInputProps) {
  const GooglePlacesAPI = useGooglePlacesApi();
  const { hostStore } = useStores();
  const { landingPageLocations } = hostStore;

  const checkCustomersWithinRangeOfPatron = useCallback(
    async (patronAddress) => {
      onLoading(true);
      const locationsWithinRangeOfPatron = await GooglePlacesAPI.getLocationsWithinRangeOfPatron(
        customersById,
        patronAddress,
        landingPageLocations.slice()
      );
      onLocationsChange(locationsWithinRangeOfPatron || []);
      onLoading(false);
    },
    [GooglePlacesAPI, customersById, landingPageLocations, onLocationsChange, onLoading]
  );

  return (
    <StyledAddressInput
      allowClear
      className={className}
      name="address"
      onAddressObjectChange={async (addressObject) => {
        onAddressObjectChange(addressObject);
        await checkCustomersWithinRangeOfPatron(addressObject);
      }}
      onQueryChange={onQueryChange}
      placeholder={placeholder}
    />
  );
}

export default observer(LandingPageAddressInput);
